import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';
import SettingsViewWrapper from '@/shared/components/SettingsViewWrapper/SettingsViewWrapper';
import { UserDetailForm } from '@/shared/components/UserDetailForm/UserDetailForm';
import { useUser } from '@/shared/hooks/user';
import { useTranslation, withTranslation } from 'react-i18next';

const UserProfile: React.FC = () => {
  const { t } = useTranslation();

  const user = useUser();

  return (
    <SettingsViewWrapper name="profile-page" title={t('settings.personal_info')}>
      {user ? <UserDetailForm user={user} /> : <LoadingSpinner />}
    </SettingsViewWrapper>
  );
};

export default withTranslation()(UserProfile);
